export default function palettesReducer(
  state = {
    background: 'dark',
    leftSidebar: 'dark',
    navbar: 'dark',
    rightSidebar: 'dark'
  },
  action
) {
  switch (action.type) {
    case 'SET_PALETTE':
      return {
        ...state,
        ...action.palette
      }
    case 'RESET_PALETTES':
      return {
        background: 'dark',
        leftSidebar: 'dark',
        navbar: 'dark',
        rightSidebar: 'dark'
      }
    default:
      return state
  }
}
